<template>
  <div v-if="sPoH.length">
    <van-popup v-model="visible" position="top" :style="{ height: '100%', width: '100%' }"
      :close-on-click-overlay="false">
      <van-nav-bar title="您的訂單 Order List" fixed placeholder />

      <!-- <van-grid column-num="1">
        <van-grid-item>
          <div class="tip">您有{{ sPoH.length }}筆訂單</div>
          <div class="tip">結帳時請提供手機號碼</div>
        </van-grid-item>
      </van-grid> -->


      <van-grid :gutter="40" :column-num="1">
        <van-grid-item v-for="h in sPoH" :key="h.OrderNo">

          <div style="text-align: center;" v-if="sGetConfig('chkPoIQrcode')">

            <vue-qr :text="h.OrderNo" :size="200"></vue-qr>

            <h3>請出示條碼供櫃檯結帳</h3>
           
          </div>
          <div style="width:100%;line-height: 1.4rem;font-size:1.2rem">


           <van-divider />
            <van-col span="24">
              <span class="C2">
                <van-icon name="orders-o" size="24" />
                訂單號碼：{{ h.OrderNo }}
              </span>
            </van-col>

            <van-row v-for="r in sPoI.filter((r) => r.OrderNo == h.OrderNo)" :key="r.rno">
              <van-col span="17">
                {{ r.ItemName }}
                <span class="note" v-if="r.Remark"> {{ r.Remark }}</span>
              </van-col>

              <van-col span="2">x<span class="C1">{{ r.Qty }}</span></van-col>
              <van-col span="5" align="right">
                <span v-if="r.Amt < 0" class="C4">{{ r.Amt }}</span>
                <span v-if="r.Amt >= 0" class="C1">{{ r.Amt }}</span>
                元
              </van-col>
            </van-row>
            <van-divider />
            <van-row>
              <van-col span="24">共 <span class="C1">{{ getSum(h).qty }} </span>項</van-col>
              <van-divider />
              <van-col span="12">合計金額 Total</van-col>
              <van-col span="12" align="right">
                <span class="C1">{{ getSum(h).amt }}</span> 元
              </van-col>
              <!-- <van-col span="12">服務費 Service</van-col>
              <van-col span="12" align="right">
                <span class="C1">{{ getSum(h).service }}</span> 元
              </van-col> -->
            </van-row>
          </div>
          <!-- {{ h }} -->
        </van-grid-item>
      </van-grid>
      <div style="height: 10rem;"></div>
      <!-- {{ sPoI }} -->
      <!-- <van-cell v-for="r in sPoH" :key="r.OrderNo" :title="r.OrderNo" :label="r.Remark" :value="'$' + getSum(r).amt"
        icon="records" size="large" is-link @click="cmdPoI(r)" /> -->

      <Footer b1="建立新訂單 Create New" @b1c="close()" anime />
      <PoI ref="rPoI" />
    </van-popup>
  </div>
</template>

<style scoped>
.van-cell {
  color: v-bind(sGetConfig("color2"));
}

.van-col {
  padding: 1rem;
}

.tip {
  color: grey;
}
</style>
<script>
export default {
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    show() {
      this.visible = true;
    },
    cmdServiceType() {
      this.visible = false;
      this.$refs.rServiceType.show();
    },
    cmdWelcome() {
      this.visible = false;
      this.$refs.rWelcome.show();
    },
    cmdOCheck() {
      this.visible = false;
      this.$refs.rOCheck.showAndLoad();
    },
    getSum(poh) {
      var poi = this.sPoI.filter((r) => r.OrderNo == poh.OrderNo);
      var sum = {};
      sum.amt = this.gSum(poi, "Amt");
      sum.qty = this.gSum(poi, "Qty");
      return sum;
    },
    cmdPoI(poh) {
      this.$refs.rPoI.show(poh);
    },
    close() {
      this.visible = false;
      this.$emit("close");
    },
  },
};
</script>
